import { LOGIN } from "../constant";

export default {
  namespaced: true,
  state: {
    name: "",
    roles: [],
    info: {}
  },

  mutations: {
    [LOGIN]: (state, payload) => {
      state.name = payload;
    }
  },
  actions: {}
};
